import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import CreateClientForm from '@/components/forms/CreateClientForm';

export const CreateClientPage = () => {
	return (
		<AuthenticatedPageLayout>
			<CreateClientForm />
		</AuthenticatedPageLayout>
	);
};
